<template>
  <g
    id="Front_Right_Indiator"
    v-on:click="changeSeverity('rearFrontRightIndicator')"
    :class="severityClass"
  >
    <rect class="cls-903" x="36.52" y="245.93" width="9.27" height="2.23" />
    <g>
      <circle
        class="cls-208"
        cx="33.31"
        cy="247.05"
        r="5.2"
        transform="translate(-61.45 16.48) rotate(-14.66)"
      />
      <circle
        class="cls-458"
        cx="33.31"
        cy="247.05"
        r="5.09"
        transform="translate(-61.41 16.46) rotate(-14.65)"
      />
      <circle
        class="cls-170"
        cx="33.31"
        cy="247.05"
        r="4.98"
        transform="translate(-61.36 16.44) rotate(-14.64)"
      />
      <circle
        class="cls-300"
        cx="33.31"
        cy="247.05"
        r="4.87"
        transform="translate(-61.29 16.41) rotate(-14.62)"
      />
      <circle
        class="cls-135"
        cx="33.31"
        cy="247.05"
        r="4.76"
        transform="translate(-61.2 16.37) rotate(-14.6)"
      />
      <circle
        class="cls-301"
        cx="33.31"
        cy="247.05"
        r="4.65"
        transform="translate(-61.06 16.32) rotate(-14.57)"
      />
      <circle class="cls-403" cx="33.31" cy="247.05" r="4.54" />
      <circle class="cls-363" cx="33.31" cy="247.05" r="4.43" />
      <circle class="cls-364" cx="33.31" cy="247.05" r="4.32" />
      <circle class="cls-31" cx="33.31" cy="247.05" r="4.22" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
